/**
 * URL pública y nombre de producto para marketing, SEO, emails y fallbacks server-side.
 */

export const PRODUCT_DISPLAY_NAME = "Structura Market";

const DEFAULT_PUBLIC_SITE = "https://food.structura.com.ar";

function stripTrailingSlash(url: string): string {
  return url.replace(/\/$/, "");
}

/** Origen canónico del sitio FM (marketing + app + storefronts en zona food). */
export function getPublicSiteUrl(): string {
  const fromProcess =
    typeof process !== "undefined"
      ? process.env.URL ?? process.env.VITE_PUBLIC_SITE_URL ?? process.env.APP_URL
      : undefined;
  const fromVite =
    typeof import.meta !== "undefined" ? import.meta.env?.VITE_PUBLIC_SITE_URL : undefined;
  return stripTrailingSlash(String(fromProcess ?? fromVite ?? DEFAULT_PUBLIC_SITE));
}

export function publicSitePath(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${getPublicSiteUrl()}${p}`;
}

/** Hostname sin protocolo — útil en mockups y QR. */
export function getPublicSiteHost(): string {
  try {
    return new URL(getPublicSiteUrl()).host;
  } catch {
    return DEFAULT_PUBLIC_SITE.replace(/^https?:\/\//, "");
  }
}
